import styles from './ForYouLeadingIcon.module.css'
import {clsx} from 'clsx'
import type {Icon as PrimerIcon} from '@primer/octicons-react'

type ForYouLeadingIconProps = {
  icon: PrimerIcon
  /** Optional visual variant controlling the leading icon color */
  variant?: 'default' | 'danger' | 'success' | 'warning' | 'info'
}

export function ForYouLeadingIcon({icon: Icon, variant = 'default'}: ForYouLeadingIconProps) {
  return (
    <span className={clsx(styles.variant, styles[variant])}>
      <Icon size={16} />
    </span>
  )
}
